import {initializeApp} from 'firebase/app';
import {getAuth} from 'firebase/auth';
import {getFirestore} from 'firebase/firestore';
import {getFunctions} from "firebase/functions";
import {getPerformance} from "firebase/performance";
import {getAnalytics} from 'firebase/analytics';

let fbApp, db, fbAuth, functions, perf, analytics;

try {
    const firebaseConfig = {
        apiKey: process.env.REACT_APP_API_KEY,
        authDomain: process.env.REACT_APP_AUTH_DOMAIN,
        projectId: process.env.REACT_APP_PROJECT_ID,
        storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
        messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
        appId: process.env.REACT_APP_APP_ID,
        databaseURL: process.env.REACT_APP_DATABASE_URL,
        measurementId: process.env.REACT_APP_MEASUREMENT_ID,
    };

    fbApp = initializeApp(firebaseConfig);
    db = getFirestore(fbApp);
    fbAuth = getAuth(fbApp);
    functions = getFunctions(fbApp);
    perf = getPerformance(fbApp);
    analytics = getAnalytics(fbApp);
} catch (e) {
    fetch(process.env.REACT_APP_LOGGING_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            message: e.message,
        }),
    })
        .then(() => console.log('admin notified'))
        .catch((error) => console.log('admin failed to be notified: ', error.message));
}

export {fbApp, db, fbAuth, functions, perf, analytics};